import React from 'react';

interface ErrorIconProps {
    id?: string;
    className?: string;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const ErrorIcon = ({ id, className, onClick }: ErrorIconProps) => (
    <svg
        id={id}
        xmlns="http://www.w3.org/2000/svg"
        width="17.658"
        height="14.5"
        viewBox="0 0 17.658 14.5"
        className={className}
        onClick={onClick}
    >
        <path
            id="warning-symbol"
            d="M17.4,53.727,10.2,42.475a1.624,1.624,0,0,0-2.735,0L.256,53.727a1.624,1.624,0,0,0,1.367,2.5h14.41a1.624,1.624,0,0,0,1.368-2.5ZM7.924,46.3a.9.9,0,0,1,1.792,0v3.843a.9.9,0,0,1-1.792,0V46.3ZM8.8,54.284a1.12,1.12,0,1,1,1.12-1.12A1.12,1.12,0,0,1,8.8,54.284Z"
            transform="translate(0 -41.727)"
            fill="#c40028"
        />
    </svg>
);

export default ErrorIcon;
